import { Button, Typography } from "@/design-system/Atoms";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/routes.config";

export const TrimixHeroContentSection = () => { 
  const navigate = useNavigate();

  const { ctaButtonConfig, patientEntitlementsIsLoading } =
    usePatientCTAButtonConfig();

  return (
    <section className="relative pb-[4.68rem] lg:pb-[10rem] pt-0 slider-offset-padding">
      <div className="w-full mx-auto box-border">
        <div className="flex flex-col xl:flex-row items-center">
          <div className="w-full !px-3 sm:px-6 xl:px-0 py-10 xl:py-0 xl:w-5/12">
            <Typography as="h1" className="mb-3" variant="sectionLargeTitle">
              Trimix Injections
            </Typography>
            <Typography
              variant="sectionDescriptionLarge"
              as="p"
              className="mb-0"
            >
              Results when you want them-even if you have severe ED. Trimix
              injections take effect in as little as five minutes on average.*
            </Typography>
            <Button
              variant="secondary"
              size="xl"
              className={`mt-10 md:flex lg:flex 'btn-secondary' }`}
              onClick={() => {
                if (ctaButtonConfig.text === "View Products") {
                  navigate(`${ROUTES.PRODUCTS_BASE}/category/ICP`);
                } else {
                  ctaButtonConfig.action();
                }
              }}
              loading={patientEntitlementsIsLoading}
            >
              {ctaButtonConfig.text}
            </Button>
          </div>
          <div className="relative w-full px-4 sm:px-6 xl:px-0 xl:ml-[8.333333%] xl:w-1/2 mt-1 xl:mt-0">
            <img
              className="w-full object-cover align-middle rounded-xl"
              src="/images/trimix/GettyImages-11978838031.png"
              alt="trimix-head-content"
            />
            <p
              className="absolute text-sm sm:text-base leading-[1.5] bg-white/5 backdrop-blur-[20px] text-white rounded-[20px]
                           p-4 sm:p-6 xl:p-8 
                           bottom-4 sm:bottom-6 xl:bottom-[40px]
                           left-4 sm:left-6 xl:left-[80px]
                           right-4 sm:right-6 xl:right-[40px]
                           mt-5 mb-4"
            >
              *Effectiveness and onset of action may vary based on the
              individual patient. Most men experience healthy and lasting
              erections minutes after administration.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrimixHeroContentSection;
